import PropTypes from "prop-types";
import React from "react";

export function BenefitImageList({ images }) {
  return (
    <ul className="flex flex-wrap max-w-lg p-4 mx-auto my-10 benefits-icons">
      {images.map(({ description, file }) => (
        <li
          key={description}
          className="p-4 mx-auto text-base font-extrabold leading-tight text-center xs:w-1/2 sm:w-1/4 sm:p-0"
        >
          <img
            alt={description}
            className="m-auto mb-5"
            style={{ height: 128 }}
            src={file.fileLocal.publicURL}
          />
          <span className="block px-4 font-semibold break-words text-smaller">
            {description}
          </span>
        </li>
      ))}
    </ul>
  );
}

BenefitImageList.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      file: PropTypes.shape({
        fileLocal: PropTypes.shape({
          publicURL: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    })
  ).isRequired,
};
